import { render, staticRenderFns } from "./SearchMovieSection.vue?vue&type=template&id=60e821d0&scoped=true&lang=pug&"
import script from "./SearchMovieSection.vue?vue&type=script&lang=js&"
export * from "./SearchMovieSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchMovieSection.vue?vue&type=style&index=0&id=60e821d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e821d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
